// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".buttons[data-v-472972ed]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-top:12px}.errors[data-v-472972ed]{margin:0;position:absolute;bottom:0;font-size:12px}.mcp-admin__form-field[data-v-472972ed]{overflow:hidden}", ""]);
// Exports
module.exports = exports;
